module.exports = __webpack_public_path__ + "static/Calibre-Medium-46b36969c7bb1d7ed4c8253e8f274788.woff2";